import { PDP_3_4_SETTINGS } from "@/data/pdp-3-4/settings";
import { PDP_3_4_PRODUCT } from "@/data/pdp-3-4/product.mock";
import { PDP_3_4_CONTENT } from "@/data/pdp-3-4/content";

// Single object consumed by the shared PDP components via PdpDataContext.
// Shopify mapping per key: src/data/_SHOPIFY_MAPPING.md
export const PDP_3_4 = { ...PDP_3_4_SETTINGS, ...PDP_3_4_PRODUCT, ...PDP_3_4_CONTENT };

export default PDP_3_4;
